import config from '@/utils/Config'
import {get, post } from '@/utils/request'

export function getDanmakuList(params = {}) {
    return get(config.BASE_URL, config.getDanmakuListUrl, params)
}

export function getDanmakuTop20(params = {}) {
    return get(config.BASE_URL, config.getDanmakuTop20Url, params)
}

export function saveDanmaku(params = { info: info }) {
    return post(config.BASE_URL, config.saveDanmakuUrl, params)
}

export function getAdminDanmakuList(params = {}) {
    return post(config.BASE_URL, config.getAdminDanmakuListUrl, params)
}

export function delDanmaku(params = { id: id }) {
    return post(config.BASE_URL, config.delUrl, params)
}